<template>
  <div>
    <van-nav-bar :right-text="username" :title="title" left-arrow left-text="返回" @click-left="onClickLeft" @click-right="goIndex()" />
    <van-cell-group>
      <van-field ref="barcode" v-model="barcode" autofocus label="条码" left-icon="photograph" placeholder="请扫描条码" @keyup="onBarcode" />
    </van-cell-group>
    <a-table :dataSource="list" :loading="loading" :pagination="false" :rowKey="(rec) => rec.index" bordered size="middle">
      <a-table-column align="center" dataIndex="command_commandStatus" title="已复核">
        <template slot-scope="text, record">
          <vxe-switch v-model="record.command_commandStatus" size="mini"/>
        </template>
      </a-table-column>
      <a-table-column align="center" dataIndex="customer.shortName" title="客户">
      </a-table-column>
      <a-table-column align="center" dataIndex="barcode.no" title="条码">
      </a-table-column>
      <a-table-column align="center" dataIndex="item.name" title="商品">
      </a-table-column>
    </a-table>
    <van-tabbar fixed placeholder>
      <van-tabbar-item>
        <van-row gutter="20">
          <van-col span="20">
            <van-button :loading="loading" block native-type="review" round style="margin: 10px;" type="info" @click="review">复核</van-button>
          </van-col>
        </van-row>
      </van-tabbar-item>
    </van-tabbar>
  </div>
</template>
<script>
import { findAll, post } from '@/api/Api'
import { getUser } from '@/pdaView/utils'
import api from '@/api'
import { Toast } from 'vant'
import storageRoomEdit from '@/views/basedata/storageroom_maintenance/StorageRoomEdit.vue'
import debounce from 'lodash/debounce'

export default {
    computed: {
      storageRoomEdit() {
        return storageRoomEdit
      }
    },
    data() {
      return {
        loading: false,
        username: getUser().name,
        selectedRowKeys: [],
        selectedRows: {},
        list: [],
        barcode: null,
        title: this.$route.params.barcode
      }
    },
    methods: {
      onBarcode: debounce(function(data, event) {
        if ([13].includes(data.keyCode)) {
          const value = _.trim(data.target.value)
          this.review(value)
        }
      }, 300),
      onClickLeft() {
        this.$router.go(-1)
      },
      onSelectChange(selectedRowKeys, selectedRows) {
        this.selectedRowKeys = selectedRowKeys
        this.selectedRows = selectedRows
        this.handleCheck()
      },
      handleCheck(record, index) {
        return {
          on: {
            click: () => {
              this.selectedRowKeys = [index]
              this.selectedRows = record
            }
          }

        }
      },
      goIndex() {
        this.$router.push({ name: 'PdaIndex' })
      },
      refresh() {
        let mewArr = []
        let args = {
          'stagingArea': this.$route.params.barcode
        }
        this.loading = true
        findAll('reviewCommandAreaFactory', args).then(res => {
          _.forEach(res.result, item => {
            item.command_commandStatus = item.command.commandStatus >= 42
            if (!item.command_commandStatus) {
              mewArr.push(item)
            }
          })
          if (mewArr.length > 0) {
            console.log(mewArr)
            this.list = mewArr
          } else {
            this.$router.go(-1)
          }
        }).finally(() => {
          this.loading = false
        })
      },
      review() {
        if (this.barcode) {
          let body = {
            'barcode.no': this.barcode
          }
          this.loading = true
          post(api.reviewReview, {}, body).then(res => {
            if (res.success) {
              Toast('复核成功！')
              this.barcode = null
              this.refresh()
            }
          }).finally(() => this.loading = false)
        } else {
          Toast('请先输入条码')
        }
      }
    },
    created: function() { // 创建生命周期
      this.refresh()
    }
  }
</script>